import React from "react";
import { Link } from "react-router-dom";
import { Card } from "./ui/card";
import Logo from "./Logo";

export const AuthShell = ({ title, subtitle, children }) => (
  <div className="relative flex min-h-screen items-center justify-center px-4 py-10">
    <div className="relative w-full max-w-md">
      <Link to="/" className="mb-6 flex items-center justify-center gap-2" data-testid="back-home-link">
        <Logo height={120} />
      </Link>
      <Card className="glass-card border-0 p-8">
        <div className="mb-7">
          <h1 className="font-display text-3xl font-medium tracking-tight sm:text-4xl">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
        </div>
        {children}
      </Card>
    </div>
  </div>
);

export const inputCls =
  "mt-1.5 border-white/10 bg-black/30 text-slate-50 placeholder:text-slate-500 focus-visible:ring-emerald-500/40 focus-visible:border-emerald-500/40";
export const labelCls = "text-slate-300 text-[11px] uppercase tracking-[0.18em]";
